import { Action } from '@ngrx/store';
export const SET_USER_PROFILE = 'SET USER PROFILE';
export const SET_REFRESH_KEY = 'UPDATE REFRESH KEY';
export const SET_FOLLOWERS = 'SET FOLLOWERS';
export const SET_OTHER_USER_PROFILE = 'SET OTHER USER PROFILE';
export class SetUserProfile implements Action {
  readonly type = SET_USER_PROFILE;
  constructor(public payload: []) {}
}
export class SetRefreshKey implements Action {
  readonly type = SET_REFRESH_KEY;
  constructor(public payload: []) {}
}
export class SetFollowers implements Action {
  readonly type = SET_FOLLOWERS;
  constructor(public payload: []) {}
}
export class SetOtherUserProfile implements Action {
  readonly type = SET_OTHER_USER_PROFILE;
  constructor(public payload: []) {}
}

export type UserProfileAction =
  | SetRefreshKey
  | SetUserProfile
  | SetFollowers
  | SetOtherUserProfile;
